import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Computed block numbering (`blockId → name`) keyed by an independent scope so
 * unrelated consumers never share a keyspace. The main document editor writes
 * under `DEFAULT_NAMES_SCOPE`; each document preview (e.g. inside the add/edit
 * reference modal) writes under its own per-instance scope and clears only that
 * scope on unmount — so a preview can never wipe the editor's numbering.
 */
export const DEFAULT_NAMES_SCOPE = 'editor';

type DocumentNamesState = {
  byScope: Record<string, Record<string, string>>;
};

const initialState: DocumentNamesState = {
  byScope: {},
};

const documentNamesSlice = createSlice({
  name: 'documentNames',
  initialState,
  reducers: {
    setScopedDocumentNames: (
      state,
      action: PayloadAction<{ scope: string; names: Record<string, string> }>,
    ) => {
      state.byScope[action.payload.scope] = action.payload.names;
    },
    clearScopedDocumentNames: (state, action: PayloadAction<string>) => {
      delete state.byScope[action.payload];
    },
  },
});

export const { setScopedDocumentNames, clearScopedDocumentNames } =
  documentNamesSlice.actions;
export default documentNamesSlice.reducer;
